import { Directive, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appSelect]'
})

export class SelectDirective {
  @Input() showSearchBar = false;

  constructor(
    private renderer: Renderer2
  ) {}

  @HostListener('document:click', ['$event'])
  clicked(ev){
    if(this.showSearchBar){
      if(ev.target.tagName === 'ION-SELECT'){
        const interval = setInterval(() => {
          const alertWrp = document.querySelector('.alert-wrapper');
          if(alertWrp){
            this.implementSearchbar(alertWrp);
            clearInterval(interval);
          }
        }, 100)
      }
    }
  }

  implementSearchbar(alertWrp: Element){
    const searchInput = document.createElement('ion-searchbar');
    let alertRadioGroup = document.querySelector('.alert-radio-group');
    if(!alertRadioGroup) alertRadioGroup = document.querySelector('.alert-checkbox-group');
    const options = document.querySelectorAll('.select-interface-option');
    this.renderer.addClass(searchInput, 'select-search')
    searchInput.showClearButton = 'never';
    searchInput.placeholder = 'Buscar...';
    alertWrp.insertBefore(searchInput, alertRadioGroup);
    searchInput.addEventListener('input', (ev: any) => {
      const search: string = ev.target.value.toLowerCase();
      options.forEach((item) => {
        const txt = item.children[0].children[1].childNodes[0].textContent.toLocaleLowerCase().trim();
        let value = '';
        if(!txt.includes(search)){
          value = 'none';
        }else{
          value = 'inline-block';
        }
        this.renderer.setStyle(item, 'display', value);
      })
    })
  }

}
